import PropTypes from 'prop-types'
import { createRef, PureComponent } from 'react'
import { Popup } from 'semantic-ui-react'

import { cn } from '@repo/utils'

import { ChildrenSchema } from 'utils'

import SimpleButton from '../../SimpleButton'
import Event from '../Event'

import styles from './index.css'

class Day extends PureComponent {
  state = {
    showMoreEvents: false,
  }

  render() {
    const titleRef = createRef()
    const {
      active = false,
      className,
      day,
      events,
      highlight = false,
      maxVisibleEvents = 5,
      onAddEvent,
      onEditEvent,
      readOnly = false,
      value,
    } = this.props
    const handleEditEvent = (evt) =>
      onEditEvent(
        evt,
        events.find((e) => e.id === evt.currentTarget.value),
      )

    const onHideMoreEvents = () => this.setState({ showMoreEvents: false })

    const onShowMoreEvents = () => this.setState({ showMoreEvents: true })

    const sortedEvents = events.sort((a, b) => a.datetime - b.datetime)

    const totalVisibleEvents = events.length <= maxVisibleEvents ? events.length : maxVisibleEvents - 1
    const totalHiddenElements = events.length - totalVisibleEvents

    const handleAddEvent = (evt) =>
      !readOnly && !this.state.showMoreEvents && evt.target.nodeName !== 'BUTTON' && onAddEvent(evt)

    return (
      <div
        className={cn(
          className,
          styles.wrapper,
          (readOnly || this.state.showMoreEvents) && styles.readOnly,
          highlight && styles.highlight,
        )}
        data-value={value}
        onClick={handleAddEvent}
        onKeyDown={handleAddEvent}
        role="button"
        tabIndex={readOnly ? -1 : 0}
      >
        <div className={cn(styles.number, active && styles.active)} ref={titleRef}>
          <span>{day}</span>
        </div>
        <div className={styles.events}>
          {sortedEvents.slice(0, totalVisibleEvents).map((event) => (
            <Event
              key={event.id}
              categoryId={event.categoryId}
              className={styles.event}
              datetime={event.datetime}
              disabled={readOnly}
              icon={event.icon}
              onClick={handleEditEvent}
              title={event.title}
              value={event.id}
            />
          ))}
        </div>
        <div className={styles.more}>
          {totalHiddenElements > 0 && (
            <SimpleButton
              disabled={readOnly || this.state.showMoreEvents}
              onClick={onShowMoreEvents}
              value={`+ ${totalHiddenElements} más`}
            />
          )}
        </div>
        {this.state.showMoreEvents && totalHiddenElements > 0 && (
          <Popup
            basic
            className={styles.popup}
            content={
              <>
                <div className={cn(styles.number, active && styles.active)}>
                  <span>{day}</span>
                </div>
                <div className={styles.moreEvents}>
                  {sortedEvents.map((event) => (
                    <Event
                      key={event.id}
                      categoryId={event.categoryId}
                      className={styles.event}
                      datetime={event.datetime}
                      disabled={readOnly}
                      icon={event.icon}
                      onClick={handleEditEvent}
                      title={event.title}
                      value={event.id}
                    />
                  ))}
                </div>
              </>
            }
            context={titleRef}
            onClose={onHideMoreEvents}
            open
            position="bottom center"
            style={{ width: (titleRef?.current?.offsetWidth || 0) + 14 }}
          />
        )}
      </div>
    )
  }
}

const CalendarEventSchema = PropTypes.shape({
  id: PropTypes.string.isRequired,
  datetime: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,

  categoryId: PropTypes.number,
  doing: PropTypes.bool,
  done: PropTypes.bool,
  icon: ChildrenSchema,
  todo: PropTypes.bool,
})

Day.propTypes = {
  day: PropTypes.string.isRequired,
  events: PropTypes.arrayOf(CalendarEventSchema).isRequired,
  onAddEvent: PropTypes.func.isRequired,
  onEditEvent: PropTypes.func.isRequired,

  active: PropTypes.bool,
  className: PropTypes.string,
  highlight: PropTypes.bool,
  maxVisibleEvents: PropTypes.number,
  readOnly: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default Day
